import React, { useState, useEffect } from 'react';
import Admin from './routes/Admin';

const ProtectedAdminRoute = () => {
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const alreadyAuthorized = localStorage.getItem('isAdminVerified');

    if (alreadyAuthorized === 'true') {
      setIsAuthorized(true);
    } else {
      const password = window.prompt('Enter Admin Password');
      if (password === 'Mans@123') {
        localStorage.setItem('isAdminVerified', 'true');
        setIsAuthorized(true);
      } else {
        alert('Incorrect password! Redirecting to Home.');
        window.location.href = '/';
      }
    }
  }, []);

  return isAuthorized ? <Admin /> : null;
};

export default ProtectedAdminRoute;
